import { forwardRef, useEffect, useRef, useState } from "react";
import { ManualAccountTaskList, ManualAccountTaskListConfig } from "./Data/GmpmanualTaskListTable.data";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { useNavigate } from "react-router-dom";
import { useDeleteManualDataByIdMutation, useGetManualAccountMemberListMutation } from "../../app/services/GMAP/gmapApplicationTaskListApi";
import { useLazyGetAllDropDownsForMemberDirectoryQuery } from "../../app/services/common/commonApi";
import { setDropDownField } from "./utils/setFieldParameter";
import { encryptAESID } from "../../utils/Encryption";
import SwalAlert from "../../services/swalService/SwalService";
import { getAuthProps } from "../../lib/authenticationLibrary";

const GmpmanualAccountTaskList = forwardRef(() => {
    const manualTaskListRef = useRef();
    const molRef = useRef();
    const navigate = useNavigate();
    const authData = getAuthProps();
    const [formData, setFromData] = useState(ManualAccountTaskList);
    const [dataSource, setDataSource] = useState();
    const [paginationRequest, setPaginationRequest] = useState({
        pageNo: 1,
        pageSize: 20,
        NameOrEmail: "",
        GmpNumber: "",
        GmpTier: null,
        GmpFlag: null,
        totalCount: 0,
    });
    const { success, error, confirm } = SwalAlert();

    const [getMemberList, { isSuccess, isLoading, data: memberListResponse }] = useGetManualAccountMemberListMutation();
    const [getAllDropdownData, { isLoading: getDropdownDataIsLoading, data: getDropdownData, isSuccess: getAllDropdownDataIsSuccess }] = useLazyGetAllDropDownsForMemberDirectoryQuery();
    const [deleteManualData, { isSuccess: isSuccessdeleteManualData, data: deleteManualDataResponse }] = useDeleteManualDataByIdMutation();
    useEffect(() => {
        getAllDropdownData();
    }, []);

    useEffect(() => {
        if (!getDropdownDataIsLoading && getAllDropdownDataIsSuccess && getDropdownData) {
            setDropDownField(getDropdownData)
        }
    }, [getDropdownDataIsLoading, getDropdownData, getAllDropdownDataIsSuccess]);

    useEffect(() => {
        if (isSuccessdeleteManualData && deleteManualDataResponse) {
            if (deleteManualDataResponse.hasError === false) {
                success("Member Deleted Successfully");
                getMemberList(paginationRequest)
            }
            else {
                error(deleteManualDataResponse.errorMessage)
            }
        }
    }, [isSuccessdeleteManualData, deleteManualDataResponse]);

    useEffect(() => {
        getMemberList(paginationRequest);
    }, []);

    useEffect(() => {
        if (!isLoading && isSuccess && memberListResponse) {
            setPaginationRequest(prev => ({ ...prev, totalCount: memberListResponse.totalCount }));
            setDataSource(memberListResponse?.itemList);
        }
    }, [isLoading, isSuccess, memberListResponse]);

    const handleSearch = () => {
        if (!manualTaskListRef.current) {
            return;
        }
        const taskListFormData = manualTaskListRef.current.getFormData();
        const updatedPaginationRequest = {
            pageNo: 1,
            pageSize: 20,
            NameOrEmail: taskListFormData?.name || "",
            GmpNumber: taskListFormData?.gmpNumber || "",
            GmpTier: taskListFormData?.gmpTier?.value || taskListFormData?.gmpTier,
            GmpFlag: taskListFormData?.flagId?.value || taskListFormData?.flagId
        };
        setPaginationRequest(updatedPaginationRequest);
        getMemberList(updatedPaginationRequest);
    };

    const handlePageChange = ({ pageNumber, pageSize }) => {
        const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
        setPaginationRequest(updatedPaginationRequest);
        getMemberList(updatedPaginationRequest);
    };

    const handleNavigate = () => {
        navigate('/createManualAccount')
    }

    const handleClear = () => {
        const formData = { ...ManualAccountTaskList };
        formData.initialState = {
            name: null,
            gmpTier: null,
            gmpNumber: null,
            flagId: null
        }

        let request = {
            ...paginationRequest,
            pageNo: 1,
            pageSize: 20,
            NameOrEmail: "",
            GmpNumber: "",
            GmpTier: null,
            GmpFlag: null,
            totalCount: 0,
        }
        setPaginationRequest(prev => { return { ...prev, ...request } });
        getMemberList(request);
        setFromData(formData);
    }

    const handleUpdateClick = (data) => {
        window.open(`/viewManualAccount/${encryptAESID(data.gmapMemberId)}`)
    }

    const handleDelete = (data) => {
        confirm('Delete', "Are you sure you want to delete", 'Yes', 'Cancel')
            .then(value => {
                if (value) {
                    const request = {
                        id: data.gmapMemberId,
                        UpdatedBy:115,
                        UpdatedAppId:authData?.adminUserId
                    }
                    deleteManualData(request)
                }
            })
    }

    const actionHandler = {
        EDIT: handleUpdateClick,
        DELETE: handleDelete,
    };



    return (
        <>
            <div className=" list-card mb-5">
                <div className="row">
                    <div className="row col-md-10">
                        {!getDropdownDataIsLoading &&
                            <FormCreator
                                ref={manualTaskListRef}
                                {...formData}
                            />
                        }
                    </div>
                    <div className="col-md-2">
                        <div className="verticle-btn-sec">
                            <div className="top-btns">
                                <Buttons
                                    buttonText="Search"
                                    buttonTypeClassName="btn success-btn"
                                    onClick={handleSearch}
                                />
                                <Buttons
                                    buttonText="Clear"
                                    buttonTypeClassName="btn btn-primary"
                                    onClick={handleClear}
                                />
                            </div>
                            <Buttons
                                buttonText="+ Create New Account"
                                buttonTypeClassName="outline-btn"
                                onClick={() => handleNavigate()}
                            />
                        </div>
                    </div>
                </div>
                <MolGrid
                    ref={molRef}
                    configuration={ManualAccountTaskListConfig}
                    dataSource={dataSource}
                    allowPagination={true}
                    isLoading={isLoading}
                    pagination={paginationRequest}
                    onPageChange={handlePageChange}
                    onActionChange={actionHandler}
                />
            </div>
        </>
    );
});

export default GmpmanualAccountTaskList;
